if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };

        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.viewer) return;

        if (this.elements.thumbnails) {
          this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
            mediaToSwitch
              .querySelector('button')
              .addEventListener(
                'click',
                this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false)
              );
          });

          if (
            this.dataset.desktopLayout.includes('thumbnail') &&
            this.mql.matches
          ) {
            this.removeListSemantic();
          }
        }

        // Existing event
        this.elements.viewer.addEventListener(
          'slideChanged',
          debounce(this.onSlideChanged.bind(this), 100)
        );

        // Mobile Swipe Detect
        this.elements.viewer.addEventListener(
          'scroll',
          debounce(() => {
            this.detectActiveMedia();
          }, 100)
        );

        this.elements.viewer.addEventListener('touchend', () => {
          setTimeout(() => {
            this.detectActiveMedia();
          }, 150);
        });

        window.addEventListener('resize', debounce(() => {
          this.detectActiveMedia();
        }, 150));

        // Initial
        setTimeout(() => {
          this.detectActiveMedia();
        }, 300);
      }

      detectActiveMedia() {
        const medias = [...this.elements.viewer.querySelectorAll('[data-media-id]')];

        if (!medias.length) return;

        let active = medias[0];
        let min = Infinity;

        medias.forEach((media) => {
          const rect = media.getBoundingClientRect();
          const distance = Math.abs(
            rect.left + rect.width / 2 - window.innerWidth / 2
          );

          if (distance < min) {
            min = distance;
            active = media;
          }
        });

        medias.forEach((m) => m.classList.remove('is-active'));
        active.classList.add('is-active');

        this.playActiveMedia(active);

        if (this.elements.thumbnails) {
          const thumb = this.elements.thumbnails.querySelector(
            `[data-target="${active.dataset.mediaId}"]`
          );

          if (thumb) {
            this.setActiveThumbnail(thumb);
          }
        }
      }

      onSlideChanged(event) {
        const current = event.detail.currentElement;

        if (!current) return;

        const thumbnail = this.elements.thumbnails?.querySelector(
          `[data-target="${current.dataset.mediaId}"]`
        );

        if (thumbnail) {
          this.setActiveThumbnail(thumbnail);
        }

        this.playActiveMedia(current);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');

        if (!activeMedia) return;

        this.elements.viewer
          .querySelectorAll('[data-media-id]')
          .forEach((element) => {
            element.classList.remove('is-active');
          });

        activeMedia.classList.add('is-active');

        if (prepend) {
          if (activeMedia.parentElement.firstChild !== activeMedia) {
            activeMedia.parentElement.prepend(activeMedia);
          }

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(
              `[data-target="${mediaId}"]`
            );

            if (
              activeThumbnail &&
              activeThumbnail.parentElement.firstChild !== activeThumbnail
            ) {
              activeThumbnail.parentElement.prepend(activeThumbnail);
            }
          }

          if (this.elements.viewer.slider) {
            this.elements.viewer.resetPages();
          }
        }

        this.preventStickyHeader();

        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({
              left: activeMedia.offsetLeft,
              behavior: 'smooth',
            });
          }

          const rect = activeMedia.getBoundingClientRect();

          if (rect.top <= -0.5) {
            window.scrollTo({
              top: rect.top + window.scrollY,
              behavior: 'smooth',
            });
          }
        });

        this.playActiveMedia(activeMedia);

        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(
            `[data-target="${mediaId}"]`
          );

          if (activeThumbnail) {
            this.setActiveThumbnail(activeThumbnail);
            this.announceLiveRegion(
              activeMedia,
              activeThumbnail.dataset.mediaPosition
            );
          }
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((button) => button.removeAttribute('aria-current'));

        thumbnail.querySelector('button').setAttribute('aria-current', true);

        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({
          left: thumbnail.offsetLeft,
          behavior: 'smooth',
        });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector(
          '.product__modal-opener--image img'
        );

        if (!image) return;

        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);

          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace(
              '[index]',
              position
            );

          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };

        image.src = image.src;
      }
playActiveMedia(activeItem) {
  if (!activeItem) return;

  window.pauseAllMedia();

  // Remove old loaders
  document.querySelectorAll(".video-thumb-loading").forEach(el => {
    el.classList.remove("video-thumb-loading");
  });

  // Active thumbnail
  let thumb = null;

  if (this.elements.thumbnails) {
    thumb = this.elements.thumbnails.querySelector(
      `[data-target="${activeItem.dataset.mediaId}"]`
    );

    if (thumb) {
      thumb.classList.add("video-thumb-loading");
    }
  }

  const stopLoader = () => {
    if (thumb) {
      thumb.classList.remove("video-thumb-loading");
    }
  };

  // Shopify deferred video
  const deferredMedia = activeItem.querySelector(".deferred-media");

  if (deferredMedia) {
    deferredMedia.loadContent(false);

    setTimeout(() => {

      const video = deferredMedia.querySelector("video");

      if (!video) {
        stopLoader();
        return;
      }

      video.muted = true;

      video.addEventListener("playing", stopLoader, { once: true });
      video.addEventListener("canplay", stopLoader, { once: true });
      video.addEventListener("error", stopLoader, { once: true });

      video.play().catch(stopLoader);

    }, 200);

    return;
  }

  // HTML5 video
  const video = activeItem.querySelector("video");

  if (video) {

    video.muted = true;

    video.addEventListener("playing", stopLoader, { once: true });
    video.addEventListener("canplay", stopLoader, { once: true });
    video.addEventListener("error", stopLoader, { once: true });

    video.play().catch(stopLoader);

    return;
  }

  // No video
  stopLoader();
}

      preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader || document.querySelector('sticky-header');

        if (!this.stickyHeader) return;

        this.stickyHeader.dispatchEvent(
          new Event('preventHeaderReveal')
        );
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;

        this.elements.viewer.slider.setAttribute(
          'role',
          'presentation'
        );

        this.elements.viewer.sliderItems.forEach((slide) =>
          slide.setAttribute('role', 'presentation')
        );
      }
    }
  );
}